import { makeStyles } from "@material-ui/core/styles";

export const useStylesUtil = makeStyles(() => ({
  srOnly: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    whiteSpace: "nowrap",
    width: 1,
  },
}));
